import React from 'react';

export const RNSwipeable = ({children}:any)=>{
    return <>{children}</>;
};